import React from 'react';

import { FormControlLabel, FormHelperText, FormControl } from '../Form';
import { Checkbox } from '../Checkbox';

function CheckboxField(props) {
  const {
    input: {
      name,
      value,
      type,
      onChange,
      checked,
      ...restInput
    },
    label,
    helperText,
    meta: { touched, error },
    required,
    disabled,
    color,
    size,
    fullWidth,
    formControlProps = {},
    formHelperTextProps,
    checkboxProps = {},
    ...custom
  } = props;

  const hasError = Boolean(touched && error);

  return (
    <FormControl
      required={required}
      variant={custom.variant}
      color={color}
      size={size}
      error={hasError}
      {...formControlProps}
      sx={{ ...formControlProps.sx, width: (fullWidth ? '100%' : undefined) }}
    >
      <FormControlLabel
        control={(
          <Checkbox
            color={color}
            {...checkboxProps}
            inputProps={{ required, ...restInput }}
          />
        )}
        name={name}
        label={label}
        disabled={disabled}
        value={value}
        onChange={onChange}
        checked={checked}
        color={color}
        size={size}
        {...custom}
      />
      {(helperText || hasError) && (
        <FormHelperText
          error={hasError}
          {...formHelperTextProps}
          sx={(theme) => ({ marginTop: theme.spacing(-0.5) })}
        >
          {hasError ? error : helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
}

export default CheckboxField;
